<ng-template #headerTmpl>
	<vlaio-tooltip-text [tooltip]="i18nKeys.Common.OrganizationNumberToolTip | translate">
		{{ i18nKeys.Common.OrganizationNumber | translate }}
	</vlaio-tooltip-text>
</ng-template>
